'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.initializeI18n = undefined;

var _getIn = require('transmute/getIn');

var _getIn2 = _interopRequireDefault(_getIn);

var _loadI18n = require('../utils/loadI18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var initializeI18n = exports.initializeI18n = function initializeI18n() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref$data = _ref.data,
      data = _ref$data === undefined ? {} : _ref$data;

  return function () {
    var preferredLanguage = (0, _getIn2.default)(['message', 'language'], data);

    var browserDefaultLanguage = navigator.languages ? navigator.languages[0] : navigator.language;

    var i18nConfig = preferredLanguage ? { locale: preferredLanguage, langEnabled: true } : {
      locale: browserDefaultLanguage ? browserDefaultLanguage.toLowerCase() : null,
      langEnabled: true
    };

    return (0, _loadI18n.loadI18n)(i18nConfig);
  };
};


//////////////////
// WEBPACK FOOTER
// ./js/actions/initializeI18n.js
// module id = 350
// module chunks = 2 3